<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <general></general>
      </v-flex>
      <v-flex xs12>
        <shipment></shipment>
      </v-flex>
      <v-flex xs12>
        <insured></insured>
      </v-flex>
      <v-flex xs12>
        <clause></clause>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE } from '@/store/types'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import General from '../query/General'
import Shipment from '../query/Shipment'
import Insured from '../query/Insured'
import Clause from '../query/Clause'

export default {
  computed: {
    cargoForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    }
  },
  methods: {
    doProceed() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'cargoQuoteRefPremium' })
    },
    async doPartialSave() {
      try {
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
  },
  components: {
    General,
    Shipment,
    Insured,
    Clause
  },
  mixins: [
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">

</style>
